import type React from "react";
import { Link } from "react-router-dom";

type Props = {
  classNames: string;
  children: React.ReactNode;
  toLinkOne: string;
  toLinkTwo: string;
  isLoading: boolean;
  onClickDelete?: () => void; //Eliminamos la orden de compra
}

export const Navegation = ({
  classNames,
  children,
  toLinkOne,
  toLinkTwo,
  isLoading,
  onClickDelete
}:Props):JSX.Element => {
  return (
    <div className="ps-breadcrumb">
      <div className={classNames}>
        <ul className="breadcrumb">
          {!isLoading && (
            <>
              <li className="text-truncate">
                <Link to={toLinkOne} className="link__develop" onAbort={onClickDelete} onClick={onClickDelete}>
                  Inicio
                </Link>
              </li>
              <li className="text-truncate">
                <Link
                  to={toLinkTwo}
                  className="link__develop" onAbort={onClickDelete} onClick={onClickDelete}>
                  Electrónica
                </Link>
              </li>
            </>
          )}
          {children}
        </ul>
      </div>
    </div>
  );
};
